import { buildStorageKeyForCompany } from 'helpers/buildStorageKeyFor';
import supportsLocalStorage from 'helpers/supportsLocalStorage';

export const LAST_VISITED_PATH_KEY = 'last_visited_path';

export const recordLastVisitedPathFor = (targetCompanyId) => {
  if (!supportsLocalStorage()) return;
  if (targetCompanyId == null) return;

  const path = `${globalThis.location.pathname}${globalThis.location.search}`;

  try {
    localStorage.setItem(
      buildStorageKeyForCompany(targetCompanyId, LAST_VISITED_PATH_KEY),
      path,
    );
  } catch {
    /* empty */
  }
};
